import { render, staticRenderFns } from "./EditorNewComment.vue?vue&type=template&id=52edda6f&scoped=true&"
import script from "./EditorNewComment.vue?vue&type=script&lang=js&"
export * from "./EditorNewComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52edda6f",
  null
  
)

export default component.exports